import { setDefaultValues } from '../../loader-base/src/helpers';

function setDefaultValuesEc(loaderConfig) {
    setDefaultValues(loaderConfig);

    loaderConfig.ignore = loaderConfig.ignore || [];
    loaderConfig.css.toggleCssWithComponent = loaderConfig.css.toggleCssWithComponent || false;

    if (loaderConfig.component.source.useClientSpecificBundle) {
        // Configuration should already be included in the bundle.
        loaderConfig.configuration.source.type = 'none';
    }

    if (typeof loaderConfig.polyfills === 'undefined') {
        loaderConfig.polyfills = {
            recommended: true,
        };
    }
}

export default setDefaultValuesEc;



// WEBPACK FOOTER //
// ./src/set-default-values-ec.js